import s from './Default.module.css';
import {MessagaChatIcon, OpenViewIcon} from '@/utils/icons';
import UserImage from "@common/Chat/components/UserImage/UserImage";
import {chatApi} from "@/api";
import useIsTechSupport from '../SupportChatButton/useIsTechSupport';
import { useSelector } from 'react-redux';
import { selectProfile } from '@store/profile.reducer';
import { useChatContext } from '../ChatContext';
const DefaultView = ({setPage, unReadChats, params}) => {
   const { chatIsDisabledButTechnicalSupportIsEnabled, isTechSupport } = useIsTechSupport() 
   const unreadCound = unReadChats.reduce((accumulator, curr) => Number(accumulator) + Number(curr.count), 0)
   const userId = useSelector(selectProfile)?.id
   const isChatEnabled = useSelector(store => store.settings.isChatEnabled);
   const chatContext = useChatContext()
   const lessonChatParams = params?.selectedTab === 'lesson' ? params : undefined;

   const open = async () => {
        if(chatIsDisabledButTechnicalSupportIsEnabled && !isTechSupport){
            const response = await chatApi.createSupportChat({
              user_id: userId,
            })

            if (response.data?.data?.chat_id) {
              chatContext.changePage('inChat', response.data?.data?.chat_id)
            }
        }
        else{
            setPage('main', null, 'create', lessonChatParams)
        }
    }

    return (
        <div className={s.page}>
            <div className={s.openIcon} onClick={open}>
                <OpenViewIcon width={'24'} height={'24'}/>
            </div>
            <div className={s.wrapper}>
                {
                    (isChatEnabled == '1') && (
                        <div className={s.chats}>
                            {unReadChats && unReadChats.slice(0,3).map(el => (
                                <div className={s.unreadEl} key={el.chatId} onClick={() => setPage('inChat', el.chatId, 'create', lessonChatParams)}>
                                    <UserImage path={el.chatAvatar} customClass={s.chatImage} previewDisabled={false}/>
                                    <div className={s.purple}>{el.count}</div>
                                </div>
                            ))}
                        </div>
                    )
                }
                
                <div className={s.messages} onClick={open}>
                    <MessagaChatIcon/>
                    {unreadCound > 0 && <div
                        className={s.purple}>{unreadCound}</div>}
                </div>
            </div>
        </div>
    )
}

export default DefaultView;
